import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Index from './pages/Index';
import Club from './pages/Club';
import Evenement from './pages/Evenement';
import Saubenoise from './pages/Saubenoise';
import Contact from './pages/Contact';
import Activity from './pages/Activity';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/home" />} />
        <Route path="/home" element={<Index />} />
        <Route path="/club" element={<Club />} />
        <Route path="/evenement" element={<Evenement />} />
        <Route path="/saubenoise" element={<Saubenoise />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/activity" element={<Activity />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
